import { render } from "./App.vue?vue&type=template&id=ac74cb52"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ac74cb52&lang=css"
script.render = render

export default script